import _styled from "@emotion/styled-base";
import { jsx } from '@emotion/core';
import React from 'react';
import { COLORS } from '../../constants';

var TableRow = _styled("tr", {
  target: "e1w41qhk0",
  label: "TableRow"
})("&:hover{background:#f9fafb;}&:hover&:nth-of-type(even){background:#f9fafb;}", function (props) {
  return {
    cursor: props.onClick ? 'pointer' : 'default',
    background: props.highlighted ? COLORS.grays.background : COLORS.white,
    '&:nth-of-type(even)': {
      background: props.highlighted ? COLORS.grays.background : COLORS.white
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvdy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJZSIsImZpbGUiOiJSb3cuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDT0xPUlMgfSBmcm9tICcuLi8uLi9jb25zdGFudHMnO1xudmFyIFRhYmxlUm93ID0gc3R5bGVkLnRyKHtcbiAgICAnJjpob3Zlcic6IHtcbiAgICAgICAgYmFja2dyb3VuZDogJyNmOWZhZmInLFxuICAgIH0sXG4gICAgJyY6aG92ZXImOm50aC1vZi10eXBlKGV2ZW4pJzoge1xuICAgICAgICBiYWNrZ3JvdW5kOiAnI2Y5ZmFmYicsXG4gICAgfSxcbn0sIGZ1bmN0aW9uIChwcm9wcykgeyByZXR1cm4gKHtcbiAgICBjdXJzb3I6IHByb3BzLm9uQ2xpY2sgPyAncG9pbnRlcicgOiAnZGVmYXVsdCcsXG4gICAgYmFja2dyb3VuZDogcHJvcHMuaGlnaGxpZ2h0ZWQgPyBDT0xPUlMuZ3JheXMuYmFja2dyb3VuZCA6IENPTE9SUy53aGl0ZSxcbiAgICAnJjpudGgtb2YtdHlwZShldmVuKSc6IHtcbiAgICAgICAgYmFja2dyb3VuZDogcHJvcHMuaGlnaGxpZ2h0ZWQgPyBDT0xPUlMuZ3JheXMuYmFja2dyb3VuZCA6IENPTE9SUy53aGl0ZSxcbiAgICB9LFxufSk7IH0pO1xuZXhwb3J0IHZhciBSb3cgPSBmdW5jdGlvbiAoX2EpIHtcbiAgICB2YXIgY2hpbGRyZW4gPSBfYS5jaGlsZHJlbiwgX2IgPSBfYS5oaWdobGlnaHRlZCwgaGlnaGxpZ2h0ZWQgPSBfYiA9PT0gdm9pZCAwID8gZmFsc2UgOiBfYiwgX2MgPSBfYS5leHBhbmRlZCwgZXhwYW5kZWQgPSBfYyA9PT0gdm9pZCAwID8gZmFsc2UgOiBfYywgX2QgPSBfYS5vbkNsaWNrLCBvbkNsaWNrID0gX2QgPT09IHZvaWQgMCA/IHVuZGVmaW5lZCA6IF9kLCB0ZXN0SWQgPSBfYVtcImRhdGEtdGVzdGlkXCJdLCBfZSA9IF9hLndyYXAsIHdyYXAgPSBfZSA9PT0gdm9pZCAwID8gZmFsc2UgOiBfZTtcbiAgICB2YXIgaHlkcmF0ZWRDaGlsZHJlbiA9IFJlYWN0LkNoaWxkcmVuLm1hcChjaGlsZHJlbiwgZnVuY3Rpb24gKGNoaWxkKSB7XG4gICAgICAgIGlmIChSZWFjdC5pc1ZhbGlkRWxlbWVudChjaGlsZCkpIHtcbiAgICAgICAgICAgIHJldHVybiBSZWFjdC5jbG9uZUVsZW1lbnQoY2hpbGQsIHsgZXhwYW5kZWQ6IGV4cGFuZGVkLCB3cmFwOiB3cmFwIH0pO1xuICAgICAgICB9XG4gICAgICAgIHJldHVybiBudWxsO1xuICAgIH0pO1xuICAgIHJldHVybiAoanN4KFRhYmxlUm93LCB7IG9uQ2xpY2s6IG9uQ2xpY2ssIGhpZ2hsaWdodGVkOiBoaWdobGlnaHRlZCwgXCJkYXRhLXRlc3RpZFwiOiB0ZXN0SWQgfSwgaHlkcmF0ZWRDaGlsZHJlbikpO1xufTtcbiJdfQ== */");

export var Row = function Row(_a) {
  var children = _a.children,
      _b = _a.highlighted,
      highlighted = _b === void 0 ? false : _b,
      _c = _a.expanded,
      expanded = _c === void 0 ? false : _c,
      _d = _a.onClick,
      onClick = _d === void 0 ? undefined : _d,
      testId = _a["data-testid"],
      _e = _a.wrap,
      wrap = _e === void 0 ? false : _e;
  var hydratedChildren = React.Children.map(children, function (child) {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        expanded: expanded,
        wrap: wrap
      });
    }

    return null;
  });
  return jsx(TableRow, {
    onClick: onClick,
    highlighted: highlighted,
    "data-testid": testId
  }, hydratedChildren);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Table/Row.js
// module id = 1252
// module chunks = 0